import type { Editor } from '@tiptap/core';

import type { PmConverters } from './../../pm-converters/collect';
import type { RicosStyles } from './../../ricos-styles';

import type { QueryItem, QueryItemCreator } from '../types';
import { Selection } from './selection';
import { EditorStateQuery } from './state';
import { StylesQuery } from './style-query';

export class EditorQuery {
  private _selection: Selection;

  private _styles: StylesQuery;

  private _state: EditorStateQuery;

  // eslint-disable-next-line no-useless-constructor
  constructor(
    private editor: Editor,
    private ricosStyles: RicosStyles,
    private converters: PmConverters
  ) {
    this._selection = new Selection(this.editor, this.converters);
    this._state = new EditorStateQuery(this.editor, this.converters);

    // add when styles theme or  doc change event
    this._styles = new StylesQuery(this.ricosStyles);

    this.editor.on('transaction', () => {
      this._selection = new Selection(this.editor, this.converters);
    });
  }

  selection(): Selection {
    return this._selection;
  }

  state(): EditorStateQuery {
    return this._state;
  }

  styles(): StylesQuery {
    return this._styles;
  }

  query: Record<string, QueryItem> = {};

  addQuery = (name: string, query: QueryItemCreator) => {
    if (this.query[name]) {
      throw `Query ${name} already exists`;
    }
    this.query[name] = query({ editorQuery: this });
  };
}
